import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "specialities",
    object: "speciality",
    header: [
      { text: "Label", value: "name" },
      { text: "Precios", value: "appointmentPrices" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
